
import Vue from 'vue'

const locales = require.context('./locale', false, /.json$/)
global['________'] = true;
delete global['________'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"mall-app-web","navigationBarBackgroundColor":"#FFFFFF","backgroundColor":"#f8f8f8"}};
global.__uniConfig.compilerVersion = '4.56';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '';
global.__uniConfig.appName = 'mall-app-web';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-product', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/product/product"+'.vue')), 'pages-product-product'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-set-set', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/set/set"+'.vue')), 'pages-set-set'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-userinfo-userinfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/userinfo/userinfo"+'.vue')), 'pages-userinfo-userinfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-cart-cart', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/cart/cart"+'.vue')), 'pages-cart-cart'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-version', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/public/version"+'.vue')), 'pages-public-version'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/public/login"+'.vue')), 'pages-public-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-register', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/public/register"+'.vue')), 'pages-public-register'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-user', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/user/user"+'.vue')), 'pages-user-user'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/order/order"+'.vue')), 'pages-order-order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-money-money', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/money/money"+'.vue')), 'pages-money-money'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-createOrder', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/order/createOrder"+'.vue')), 'pages-order-createOrder'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-orderDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/order/orderDetail"+'.vue')), 'pages-order-orderDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-address-address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/address/address"+'.vue')), 'pages-address-address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-address-addressManage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/address/addressManage"+'.vue')), 'pages-address-addressManage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-money-pay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/money/pay"+'.vue')), 'pages-money-pay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-money-paySuccess', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/money/paySuccess"+'.vue')), 'pages-money-paySuccess'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice-notice', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/notice/notice"+'.vue')), 'pages-notice-notice'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-category-category', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/category/category"+'.vue')), 'pages-category-category'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/product/list"+'.vue')), 'pages-product-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-coupon-couponList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/coupon/couponList"+'.vue')), 'pages-coupon-couponList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-brand-brandDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/brand/brandDetail"+'.vue')), 'pages-brand-brandDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-brand-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/brand/list"+'.vue')), 'pages-brand-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-newProductList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/product/newProductList"+'.vue')), 'pages-product-newProductList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-hotProductList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/product/hotProductList"+'.vue')), 'pages-product-hotProductList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-readHistory', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/user/readHistory"+'.vue')), 'pages-user-readHistory'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-productCollection', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/user/productCollection"+'.vue')), 'pages-user-productCollection'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-brandAttention', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/user/brandAttention"+'.vue')), 'pages-user-brandAttention'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-money-StripeProvider', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/money/StripeProvider"+'.vue')), 'pages-money-StripeProvider'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-money-LinkPay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/money/LinkPay"+'.vue')), 'pages-money-LinkPay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-error', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/root/.ci/workspace/NXE/mall_app_web/src/pages/public/error"+'.vue')), 'pages-public-error'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/product/product',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"%details%","titleNView":false})
      },
      [
        createElement('pages-product-product', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-product',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/product',
  windowTop:0
}
},
{
path: '/pages/set/set',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"设置"})
      },
      [
        createElement('pages-set-set', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-set-set',
  isNVue:false,maxWidth:0,
  pagePath:'pages/set/set',
  windowTop:44
}
},
{
path: '/pages/userinfo/userinfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改资料"})
      },
      [
        createElement('pages-userinfo-userinfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-userinfo-userinfo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/userinfo/userinfo',
  windowTop:44
}
},
{
path: '/pages/cart/cart',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"%cart%","titleNView":false})
      },
      [
        createElement('pages-cart-cart', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-cart-cart',
  isNVue:false,maxWidth:0,
  pagePath:'pages/cart/cart',
  windowTop:0
}
},
{
path: '/pages/public/version',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-public-version', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-version',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/version',
  windowTop:0
}
},
{
path: '/pages/public/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-public-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/login',
  windowTop:0
}
},
{
path: '/pages/public/register',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-public-register', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-register',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/register',
  windowTop:0
}
},
{
path: '/pages/user/user',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"%my%","titleNView":false})
      },
      [
        createElement('pages-user-user', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-user',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/user',
  windowTop:0
}
},
{
path: '/pages/order/order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"%myOrders%","titleNView":false})
      },
      [
        createElement('pages-order-order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-order',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/order',
  windowTop:0
}
},
{
path: '/pages/money/money',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-money-money', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-money-money',
  isNVue:false,maxWidth:0,
  pagePath:'pages/money/money',
  windowTop:44
}
},
{
path: '/pages/order/createOrder',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"%details%","titleNView":false})
      },
      [
        createElement('pages-order-createOrder', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-createOrder',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/createOrder',
  windowTop:0
}
},
{
path: '/pages/order/orderDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"%details%","titleNView":false})
      },
      [
        createElement('pages-order-orderDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-orderDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/orderDetail',
  windowTop:0
}
},
{
path: '/pages/address/address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收货地址","titleNView":false})
      },
      [
        createElement('pages-address-address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-address-address',
  isNVue:false,maxWidth:0,
  pagePath:'pages/address/address',
  windowTop:0
}
},
{
path: '/pages/address/addressManage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","titleNView":false})
      },
      [
        createElement('pages-address-addressManage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-address-addressManage',
  isNVue:false,maxWidth:0,
  pagePath:'pages/address/addressManage',
  windowTop:0
}
},
{
path: '/pages/money/pay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付","titleNView":false})
      },
      [
        createElement('pages-money-pay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-money-pay',
  isNVue:false,maxWidth:0,
  pagePath:'pages/money/pay',
  windowTop:0
}
},
{
path: '/pages/money/paySuccess',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"%paymentResult%","titleNView":false})
      },
      [
        createElement('pages-money-paySuccess', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-money-paySuccess',
  isNVue:false,maxWidth:0,
  pagePath:'pages/money/paySuccess',
  windowTop:0
}
},
{
path: '/pages/notice/notice',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"通知"})
      },
      [
        createElement('pages-notice-notice', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notice-notice',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice/notice',
  windowTop:44
}
},
{
path: '/pages/category/category',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分类"})
      },
      [
        createElement('pages-category-category', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-category-category',
  isNVue:false,maxWidth:0,
  pagePath:'pages/category/category',
  windowTop:44
}
},
{
path: '/pages/product/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"商品列表"})
      },
      [
        createElement('pages-product-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/list',
  windowTop:44
}
},
{
path: '/pages/coupon/couponList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"优惠券列表"})
      },
      [
        createElement('pages-coupon-couponList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-coupon-couponList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/coupon/couponList',
  windowTop:44
}
},
{
path: '/pages/brand/brandDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"品牌详情"})
      },
      [
        createElement('pages-brand-brandDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-brand-brandDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/brand/brandDetail',
  windowTop:44
}
},
{
path: '/pages/brand/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"推荐品牌列表"})
      },
      [
        createElement('pages-brand-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-brand-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/brand/list',
  windowTop:44
}
},
{
path: '/pages/product/newProductList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"新鲜好物"})
      },
      [
        createElement('pages-product-newProductList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-newProductList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/newProductList',
  windowTop:44
}
},
{
path: '/pages/product/hotProductList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"人气推荐"})
      },
      [
        createElement('pages-product-hotProductList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-hotProductList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/hotProductList',
  windowTop:44
}
},
{
path: '/pages/user/readHistory',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"我的足迹","titleNView":{"buttons":[{"text":"清空","fontSize":"16","color":"#303133","width":"46px","background":"rgba(0,0,0,0)"}]}})
      },
      [
        createElement('pages-user-readHistory', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-readHistory',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/readHistory',
  windowTop:44
}
},
{
path: '/pages/user/productCollection',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"我的收藏","titleNView":{"buttons":[{"text":"清空","fontSize":"16","color":"#303133","width":"46px","background":"rgba(0,0,0,0)"}]}})
      },
      [
        createElement('pages-user-productCollection', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-productCollection',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/productCollection',
  windowTop:44
}
},
{
path: '/pages/user/brandAttention',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"我的关注","titleNView":{"buttons":[{"text":"清空","fontSize":"16","color":"#303133","width":"46px","background":"rgba(0,0,0,0)"}]}})
      },
      [
        createElement('pages-user-brandAttention', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-brandAttention',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/brandAttention',
  windowTop:44
}
},
{
path: '/pages/money/StripeProvider',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"stripe支付","titleNView":false})
      },
      [
        createElement('pages-money-StripeProvider', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-money-StripeProvider',
  isNVue:false,maxWidth:0,
  pagePath:'pages/money/StripeProvider',
  windowTop:0
}
},
{
path: '/pages/money/LinkPay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"支付","titleNView":false})
      },
      [
        createElement('pages-money-LinkPay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-money-LinkPay',
  isNVue:false,maxWidth:0,
  pagePath:'pages/money/LinkPay',
  windowTop:0
}
},
{
path: '/pages/public/error',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"error","titleNView":false})
      },
      [
        createElement('pages-public-error', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-error',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/error',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
